// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-Footer-FooterElement----footerelement-module---container---32XRF","row":"src-components-Footer-FooterElement----footerelement-module---row---1jSbU","col1":"src-components-Footer-FooterElement----footerelement-module---col1---1Lsun","col2":"src-components-Footer-FooterElement----footerelement-module---col2---Gj2oo","icon":"src-components-Footer-FooterElement----footerelement-module---icon---6b-U-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/FooterElement/footerelement.module.css
// module id = 319
// module chunks = 114276838955818